import payApis from '../../service/apis/couponpay.js'

const GET_PAYCOUPON_INFO = 'GET_PAYCOUPON_INFO'
const GET_PAYLINK_INFO = 'GET_PAYLINK_INFO'
const GET_POLLING_STATUS = 'GET_POLLING_STATUS'
const GET_ENOUGHPAY_INFO = 'GET_ENOUGHPAY_INFO'
const UPDATE_ISPAYBTNDISABLE = 'UPDATE_ISPAYBTNDISABLE'

let timer = null

function queryExportStatus (json, commit) {
  const get = (json, resolve) => {
    return payApis.getRechargeStatus(json).then(data => {
      if (!data.data) {
        timer = setTimeout(() => {
          get(json, resolve)
        }, 2000)
      } else {
        // commit(GET_POLLING_STATUS, response)
        resolve(data)
      }
    })
      .catch(function (error) {
        console.log(error)
      })
  }

  var p = new Promise(function (resolve) {
    get(json, resolve)
  })
  return p
}

export default {
  namespaced: true,
  state: {
    couponInfo: {},
    payLinkInfo: {},
    pollingStatus: 0,
    enoughPayInfo: null,
    isPayBtnDisable:false
  },
  mutations: {
    [GET_PAYCOUPON_INFO] (state, param) {
      state.couponInfo = param.data
    },
    [GET_PAYLINK_INFO] (state, param) {
      state.payLinkInfo = param.data
    },
    [GET_POLLING_STATUS] (state, param) {
      state.pollingStatus = param.data
    },
    [GET_ENOUGHPAY_INFO] (state, param) {
      state.enoughPayInfo = param.data
    },
    [UPDATE_ISPAYBTNDISABLE] (state, param) {
      state.isPayBtnDisable = param
    },
  },
  actions: {
    getPayOrderInfo ({ commit, state }, data) { // 查询订单支付信息
      console.log('sss')
      payApis.getPayOrderInfo(data).then(function (response) {
        commit(GET_PAYCOUPON_INFO, response)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    getPayLink ({ commit, state }, data) { // 获取支付链接
      payApis.getPayLinkInfo(data).then(function (response) {
        commit(GET_PAYLINK_INFO, response)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    stopPolling ({ commit, state }, data) { // 停止轮询
      clearTimeout(timer)
    },
    pollingPayStatus ({ commit, state }, data) { // 轮询支付状态
      // fix by limeng : reset pollingPayStatus
      commit(GET_POLLING_STATUS, {data: 0})
      payApis.getRechargeStatus(data).then(response => {
        // commit(GET_POLLING_STATUS, response)
        if (!response.data) { // 轮询未结束
          queryExportStatus(data, commit).then(json => {
            commit(GET_POLLING_STATUS, json)
          })
        } else commit(GET_POLLING_STATUS, response)
      })
        .catch(function (error) {
          console.log(error)
        })
    },
    enoughPay ({ commit, state }, data) { // 余额充足直接支付
      commit(UPDATE_ISPAYBTNDISABLE, true)
      payApis.payByBalance(data).then(function (response) {
        commit(GET_ENOUGHPAY_INFO, response)
        commit(UPDATE_ISPAYBTNDISABLE, false)
      }).catch(function (error) {
        commit(UPDATE_ISPAYBTNDISABLE, false)
      })
    }
  }
}
